<template>
  <div class="support-all">
    <div class="page-wit">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/partner/tit-l.png" width="34" />
          </span>支持与优势
          <span class="tit-r">
            <img src="@/assets/images/partner/tit-r.png" width="35" />
          </span>
        </h2>
      </div>
      <div class="interest-block bg-a">
        <span class="col-b-a"></span>
        <span class="col-b-b"></span>
        <h2>品牌优势</h2>
        <p>美菜网作为行业知名品牌，更容易获得市场认可。</p>
      </div>
      <div class="interest-block bg-a fl-r">
        <span class="col-a-a"></span>
        <span class="col-a-b"></span>
        <h2>产品优势</h2>
        <p>美菜拥有近万种商品资源，全面满足商户一站式购买需求，我们几乎与业内所有全国性大品牌签订了战略合作协议，初步建立了餐饮行业所需的核心商品的全球源头采购体系、全国联采体系和自有品牌体系。</p>
      </div>
      <div class="interest-block bg-b marg-top">
        <span class="col-a-a"></span>
        <span class="col-a-b"></span>
        <h2>完善的培训支持</h2>
        <p>嫁接近百个城市运作经验，通过集中培训、线上培训等方式，为代理商提供经营管理、人员管理、技术管理、市场营销等方面的全方位培训支持。</p>
      </div>
      <div class="interest-block bg-c fl-r marg-top">
        <span class="col-b-a"></span>
        <span class="col-b-b"></span>
        <h2>专业的运营支持</h2>
        <p>专业的平台运营团队，提供成熟明晰的战略指导方向。</p>
      </div>
      <div class="interest-block bg-c marg-top">
        <span class="col-c-a"></span>
        <span class="col-c-b"></span>
        <h2>强大的技术支持</h2>
        <p>美菜自建数百人研发团队，历时六年，打造了生鲜B2B行业最高效、智能IT系统为代理商提供了强大、全面的技术保障。</p>
      </div>
    </div>
  </div>
</template>

<script>
// import partnerForm from "./partnerForm";
export default {
  name: "support",
  // components: {
  //   partnerForm,
  // },
  data() {
    return {
      dialogVisbility: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.support-all {
  background: url(~@/assets/images/partner/advan-bg.jpg) no-repeat center top;
  overflow: hidden;
  padding-top: 80px;
  .title {
    height: 125px;
    h2 {
      font-size: 34px;
      position: relative;
      width: 340px;
      margin: 0 auto;
      text-align: center;
    }
  }
}
.interest-block {
  width: 460px;
  height: 220px;
  float: left;
  border: 1px solid #d8d8d8;
  position: relative;
  background: #fafafa;
  .col-a-a {
    position: absolute;
    width: 60px;
    height: 4px;
    left: -1px;
    top: -1px;
    background: #f76064;
  }
  .col-a-b {
    position: absolute;
    width: 20px;
    height: 20px;
    right: -1px;
    bottom: -1px;
    background: #f76064;
  }
  .col-b-a {
    position: absolute;
    width: 60px;
    height: 4px;
    left: -1px;
    top: -1px;
    background: #56cadc;
  }
  .col-b-b {
    position: absolute;
    width: 20px;
    height: 20px;
    right: -1px;
    bottom: -1px;
    background: #56cadc;
  }
  .col-c-a {
    position: absolute;
    width: 60px;
    height: 4px;
    left: -1px;
    top: -1px;
    background: #f5a623;
  }
  .col-c-b {
    position: absolute;
    width: 20px;
    height: 20px;
    right: -1px;
    bottom: -1px;
    background: #f5a623;
  }
  .col-d-a {
    position: absolute;
    width: 60px;
    height: 4px;
    left: -1px;
    top: -1px;
    background: #7b82eb;
  }
  .col-d-b {
    position: absolute;
    width: 20px;
    height: 20px;
    right: -1px;
    bottom: -1px;
    background: #7b82eb;
  }
  h2 {
    padding: 35px 0 0 40px;
    font-size: 24px;
  }
  p {
    padding: 25px 90px 0 40px;
    font-size: 15px;
    line-height: 1.7;
    text-align: justify;
  }
}
.fl-r {
  float: right;
}
.marg-top {
  margin-top: 40px;
}
</style>
